import { render, staticRenderFns } from "./SuggestionUnlogin.vue?vue&type=template&id=6ec4dcdf&scoped=true"
import script from "./SuggestionUnlogin.vue?vue&type=script&lang=js"
export * from "./SuggestionUnlogin.vue?vue&type=script&lang=js"
import style0 from "./SuggestionUnlogin.vue?vue&type=style&index=0&id=6ec4dcdf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec4dcdf",
  null
  
)

export default component.exports